'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function normDomain(url) {
    if (!url) {
        console.warn("\"url\" should be a string!", url);
        return url;
    }
    url = url.replace('http://', '').replace('https://', '');
    if (url.indexOf('/') !== -1) {
        url = url.slice(0, url.indexOf('/'));
    }
    return url;
}

exports.normDomain = normDomain;
